import { createAsyncThunk } from "@reduxjs/toolkit";
import { controlledVocabularies } from "../../../API/ControlledVocabularies";

const getAllRouteOfAdministration = createAsyncThunk(
  "controlledVocabularies/getAllRouteOfAdministration",
  async () => {
    try {
      const data = await controlledVocabularies.getManyRouteOfAdministration()
      return data;
    } catch (err) {
      console.log("error");
      ;
    }
  }
);

export { getAllRouteOfAdministration };